import {
  Component, Input, OnInit,
} from '@angular/core';
import { Unsubscriber } from '@utils/mixins/unsubscribe.mixin';
import { RouterService } from '../router.service';

@Component({
  selector: 'ba-route',
  template: `
  <ng-container *ngIf="_showContent">
    <ng-content></ng-content>
  </ng-container>
  `,
})
export class RouteComponent extends Unsubscriber() implements OnInit {
  @Input() route!: string;

  _showContent: boolean = false;

  constructor(
    private readonly router: RouterService,
  ) { super(); }

  ngOnInit(): void {
    this.initRouteListener();
  }

  initRouteListener() {
    this.subsink.sink = this.router.route$.subscribe(
      route => this._showContent = this.route === route,
    );
  }
}
